import Chip from '@carvana/ds-chip';
import { SlateLogo } from '@carvana/ds-icons';
import cx from 'classnames';
import { ShoppingCart } from 'lucide-react';
import React from 'react';
import { Summary } from '|/app/services';
import useAnalyticsContext from '|/hooks/use-analytics-context';
import CarvanaWordmark from './carvana-wordmark';
import styles from './slate-header.module.css';
import ImpersonationBanner from '../impersonation-baner';

interface SlateHeaderProps {
  orderSummary?: Summary | null;
  isOrderSummaryModalOpen?: boolean;
  setIsOrderSummaryModalOpen?: (isOpen: boolean) => void;
  inlineBrand?: boolean;
}

const SlateHeader: React.FC<SlateHeaderProps> = ({
  orderSummary = null,
  isOrderSummaryModalOpen = false,
  setIsOrderSummaryModalOpen,
  inlineBrand = false
}) => {
  const { trackEvent } = useAnalyticsContext();

  const onLogoClick = () => {
    trackEvent('pp_clicked_logo_icon');
    window.location.href = '/';
  };

  const onOrderSummaryClick = () => {
    trackEvent('pp_header_cart_clicked');
    setIsOrderSummaryModalOpen?.(true);
  };

  const showOrderSummary = Boolean(setIsOrderSummaryModalOpen && orderSummary?.vehicle);

  return (
    <>
      <ImpersonationBanner />
      <header className={styles.header}>
        <div className={cx(styles.brand, inlineBrand && styles.brandInline)}>
          <a
            href="/"
            className={styles.logoLink}
            onClick={e => {
              e.preventDefault();
              onLogoClick();
            }}
            data-analytics-id="pp_header_home"
            aria-label="Slate Home"
          >
            <SlateLogo className={styles.slateLogo} color="currentColor" />
          </a>
          <span className={styles.poweredBy}>
            <span className={styles.poweredByText}>Powered by</span>
            <CarvanaWordmark className={styles.carvanaWordmark} />
          </span>
        </div>

        {showOrderSummary && (
          <Chip
            shape="rectangle"
            size="default"
            icon={<ShoppingCart size={16} color="currentColor" />}
            iconPosition="left"
            onClick={onOrderSummaryClick}
            selected={isOrderSummaryModalOpen}
            className={styles.orderSummaryChip}
            data-analytics-id="pp_header_cart"
          >
            Order Summary
          </Chip>
        )}
      </header>
    </>
  );
};

export default SlateHeader;
